module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    class: _vm.data,
    attrs: {
      "id": "haileyBackground",
      "transform": "translate(1718.000000, 300.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "haileyBackground_hair"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.1082157,63 L52.849429,63 C52.849429,44.2819579 52.849429,31.1647509 52.849429,23.648379 C52.849429,17.4021641 55.5084429,0.253383876 38.4783868,0.00786781576 C17.3496261,-0.29673776 14.324647,8.2791696 14.1082157,19.5014593 C13.9639281,26.9829858 13.9639281,41.4824994 14.1082157,63 Z",
      "fill": "#E39B4A"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.0679159,107.674336 C5.8307958,109.075585 4.73346275,109.707334 3.52671013,111.21726 C2.11872822,112.97897 1.6876305,116.459485 0,119.197815 C0.242088927,119.924326 2.53998596,118.980371 3.15610467,117.870556 C3.77222339,116.760741 4.24971886,115.855325 4.44565848,115.580763 C4.6415981,115.3062 5.00640521,115.383629 5.07353788,115.681917 C5.14067056,115.980205 3.77530146,126.236805 3.92552024,126.773038 C4.07573902,127.309272 5.3525525,127.525223 5.65704945,127.04117 C5.9615464,126.557117 7.24048715,118.472762 7.38353387,118.273236 C7.5265806,118.07371 7.79100932,118.221352 7.89158848,118.351909 C7.99216765,118.482467 6.38914703,127.081779 6.52818954,127.432555 C6.66723205,127.78333 7.99784977,127.932325 8.18381662,127.688933 C8.36978346,127.445542 9.81259149,118.849598 9.98793763,118.676535 C10.1632838,118.503472 10.4509185,118.570433 10.5419479,118.762325 C10.6329773,118.954216 8.96578432,127.188699 9.11408091,127.576501 C9.2623775,127.964304 10.5428576,128.168347 10.7193263,127.825078 C10.895795,127.481809 12.5070992,119.19069 12.6508218,119.08889 C12.7945445,118.98709 12.9596767,119.024264 13.0601848,119.152281 C13.1606929,119.280297 12.2777727,125.522486 12.4274302,125.892353 C12.5770877,126.26222 13.5339189,126.492306 13.7446054,126.096321 C13.9552919,125.700336 15.7291318,110.425035 15.8845407,109.586142 C16.4024511,106.790474 15.1998213,103.600388 11.8345424,103.079265 C8.46926343,102.558142 6.57711166,104.665269 6.0679159,107.674336 Z",
      "id": "haileyBackground_right_hand",
      "fill": "#EFAC60"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.7357634,79.0613183 C18.4927215,79.4865655 20.3736954,82.007842 19.9370361,84.6927471 L15.9838284,109 L6,107.460044 L9.95320769,83.1527908 C10.389867,80.4678858 12.9788053,78.6360712 15.7357634,79.0613183 Z",
      "id": "haileyBackground_right_arm_bottom",
      "fill": "#E9973B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.7614204,48.0606022 C23.5017905,48.480883 25.3714469,50.9727137 24.9374149,53.626262 L19.986343,83.8957093 C19.5523111,86.5492575 16.9789497,88.3596786 14.2385796,87.9393978 C11.4982095,87.519117 9.62855307,85.0272863 10.0625851,82.373738 L15.013657,52.1042907 C15.4476889,49.4507425 18.0210503,47.6403214 20.7614204,48.0606022 Z",
      "id": "haileyBackground_right_arm_top",
      "fill": "#E9973B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.5269381,187 L28,187 L28,212 L21.8204749,212 C21.8204749,211.051203 21.298003,210.57074 20.2530592,210.558613 C19.2081155,210.546486 18.6926272,211.026948 18.7065945,212 L2,212 C2.33261498,208.215342 3.48751007,205.878294 5.46468527,204.988856 C10.8758324,202.554636 13.8786425,199.662521 14.5256826,197.286219 C15.0065956,195.520031 15.3403475,192.091291 15.5269381,187 Z",
      "id": "haileyBackground_right_shoe",
      "fill": "#AE6C23"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22,146 L22,146 L22,146 C25.3137085,146 28,148.686292 28,152 L28,187 L16,187 L16,152 L16,152 C16,148.686292 18.6862915,146 22,146 Z",
      "id": "haileyBackground_right_leg_bottom",
      "fill": "#EFAC60"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "haileyBackground_right_leg_top",
      "fill": "#EFAC60",
      "x": "16",
      "y": "104",
      "width": "12",
      "height": "54",
      "rx": "6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.5269381,187 L49,187 L49,212 L42.8204749,212 C42.8204749,211.051203 42.298003,210.57074 41.2530592,210.558613 C40.2081155,210.546486 39.6926272,211.026948 39.7065945,212 L23,212 C23.332615,208.215342 24.4875101,205.878294 26.4646853,204.988856 C31.8758324,202.554636 34.8786425,199.662521 35.5256826,197.286219 C36.0065956,195.520031 36.3403475,192.091291 36.5269381,187 Z",
      "id": "haileyBackground_left_shoe",
      "fill": "#AE6C23"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42,146 L42,146 L42,146 C45.3137085,146 48,148.686292 48,152 L48,187 L36,187 L36,152 L36,152 C36,148.686292 38.6862915,146 42,146 Z",
      "id": "haileyBackground_left_leg_bottom",
      "fill": "#EFAC60"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "haileyBackground_left_leg_top",
      "fill": "#EFAC60",
      "x": "36",
      "y": "104",
      "width": "12",
      "height": "54",
      "rx": "6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18.161751,84 C12.1339649,104.241378 9.08004795,114.888678 9,115.941902 C10.0562829,117.806229 12.2334052,119.301621 15.0908528,120.427652 C15.2275104,120.330395 15.5792924,119.906212 16.1461988,119.155105 C16.0746588,120.088338 16.0746588,120.6421 16.1461988,120.81639 C18.2402699,121.537226 20.637255,122.079752 23.1894283,122.443825 C23.2974497,122.308379 23.5550416,121.7659 23.962204,120.81639 C24.1281086,121.743495 24.2722235,122.338423 24.3945488,122.601174 C26.5405149,122.856009 28.776711,122.988978 31.0197859,123 C31.1238548,122.81245 31.3669183,122.190183 31.7489762,121.133199 C32.0056309,122.208027 32.197972,122.82784 32.3259994,122.992636 C34.3605632,122.959688 36.3874737,122.826356 38.3444912,122.592581 C38.4358559,122.42094 38.5515007,121.819214 38.6914255,120.787404 C39.141556,121.725871 39.4531012,122.271268 39.6260611,122.423595 C42.1765862,122.054921 44.5800932,121.509571 46.6914167,120.787404 C46.7499078,120.607391 46.7499078,120.063291 46.6914167,119.155105 C47.2120932,119.809828 47.5936988,120.213756 47.8362334,120.366888 C50.6724675,119.248441 52.8655067,117.77358 54,115.941902 C53.9411178,114.718716 51.0048856,104.071415 45.1913035,84 L18.161751,84 Z",
      "id": "haileyBackground_skirt",
      "fill": "#AE6C23"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.1546679,47 C35.2524513,47 44.4395859,47.5716428 47,48.370045 C46.4861641,55.3289061 45.3763411,64.7005493 44.3028947,72.9672872 C44.1858661,78.1452795 44.3028947,80.714114 45.6011061,84.2227196 C41.3332545,85.5111593 23.4806063,84.9726079 18.5769871,84.2227196 C19.1384398,80.2326057 19.2179196,78.8949251 18.5769871,72.2704049 C12.8487475,66.8542677 18.5769871,57.9745921 17.7675001,49.076178 C21.1016293,47.2123035 29.0568845,47 32.1546679,47 Z",
      "id": "haileyBackground_top_3",
      "fill": "#FBD79E"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.348491,47 C35.521142,47 46.7427236,47.6661322 48.3527853,48.7197183 C49.9628469,49.7733045 48.1327241,86.3157551 47.552607,89.7994723 C46.9724898,93.2831894 35.1605185,94.4970517 34.5692406,90.4988148 C33.9779627,86.5005779 34.2557687,62.4981614 38.886273,48.7197183 C38.1438395,48.3900214 26.6433991,48.2538109 25.495169,48.3900214 C24.8533094,53.1829 27.289753,87.6918186 25.495169,90.4988148 C23.5311409,93.5708467 15.6117108,92.5934731 14.2772715,90.4988148 C12.9428322,88.4041565 16.8158603,50.3126117 17.6136124,49.1064504 C18.4113644,47.9002892 29.17584,47 32.348491,47 Z",
      "id": "haileyBackground_top_2",
      "fill": "#DD8C32"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.5380887,41 C43.646483,41 43.5854888,47.0601768 42.6070582,50.8418567 C41.6286277,54.6235367 40.6119866,57.6681872 35.8858114,60 C36.2977696,55.9904939 37.6272601,50.8418567 38.406279,48.3139255 C37.1200142,48.3139255 26.7209958,48.3139255 25.4096554,48.3139255 C25.1562712,51.3562579 25.4096554,55.4361951 25.4096554,60 C22.4633783,57.8149824 20.7517816,55.6212745 20.1970113,50.8418567 C19.6422409,46.062439 19.4296944,41 31.5380887,41 Z",
      "id": "haileyBackground_top_1",
      "fill": "#E9973B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.9520827,109.401402 C41.9425604,110.816667 41.0065574,111.605685 40.1014495,113.27569 C39.0454123,115.224174 39.170277,118.71544 38,121.667746 C38.3384513,122.34589 40.3562642,121.06662 40.7667284,119.880426 C41.1771925,118.694232 41.4884007,117.730337 41.6308826,117.430246 C41.7733645,117.130156 42.1283434,117.150763 42.2369529,117.43411 C42.3455625,117.717457 42.6241696,128.020216 42.8472006,128.52509 C43.0702315,129.029963 44.3042576,129.047908 44.5169362,128.52509 C44.7296147,128.002271 44.7007369,119.850632 44.8048968,119.632455 C44.9090566,119.414277 45.180308,119.519287 45.2948203,119.632455 C45.4093325,119.745622 45.2118193,128.45348 45.3960741,128.777526 C45.580329,129.101572 46.8547658,129.045418 46.9926163,128.777526 C47.1304669,128.509634 47.1777793,119.82951 47.3163563,119.632455 C47.4549334,119.435399 47.73572,119.457466 47.8505955,119.632455 C47.9654709,119.807443 47.6519925,128.166011 47.8505955,128.52509 C48.0491984,128.884168 49.284859,128.889835 49.3985539,128.52509 C49.5122489,128.160345 49.7645209,119.754551 49.8842094,119.632455 C50.0038978,119.510358 50.1649051,119.521777 50.2789633,119.632455 C50.3930215,119.743132 50.5137088,126.021331 50.7108588,126.36255 C50.9080087,126.703769 51.8431769,126.784394 51.9810275,126.36255 C52.1188781,125.940706 51.4597126,110.636228 51.4780669,109.786893 C51.5392336,106.95643 49.9217572,104 46.6765761,104 C43.4313949,104 41.9725311,106.362238 41.9520827,109.401402 Z",
      "id": "haileyBackground_left_hand",
      "fill": "#EFAC60"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47,80 L47,80 L47,80 C49.7614237,80 52,82.2385763 52,85 L52,110 L42,110 L42,85 L42,85 C42,82.2385763 44.2385763,80 47,80 Z",
      "id": "haileyBackground_left_arm_bottom",
      "fill": "#E9973B"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "haileyBackground_left_arm_top",
      "fill": "#E9973B",
      "x": "42",
      "y": "49",
      "width": "10",
      "height": "41",
      "rx": "5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.3384024,42.5906321 C27.7447272,45.2659602 27.3384024,48.6107415 25,48.6107415 C25.3370316,50.2094164 27.0455004,53 30.3451567,53 C33.644813,53 37.3286077,51.4198199 38,48.6107415 C35.3651483,48.6107415 34.7407635,45.5798566 35.3651483,42.5906321 C34.5892556,40.433836 28.4218346,40.5060499 27.3384024,42.5906321 Z",
      "id": "haileyBackground_neck",
      "fill": "#EFAC60"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "haileyBackground_head"
    }
  }, [_c('path', {
    attrs: {
      "d": "M49.1222157,24.5974477 C50.1593137,23.9885686 51.6481732,23.2150728 53.3362274,24.5974477 C54.7801159,25.7798714 53.6947505,30.418647 51.7470016,32.9875863 C49.8177124,35.5321786 46.6793609,36.060485 45.4475156,35.085121 C42.8486188,40.9329718 36.2251358,44.0383064 31.7986293,43.9996433 C19.9479403,43.8961342 15,31.9218929 15,21.9755293 C15,6.28693535 21.2814638,1.00039071 31.7986293,1.00039071 C41.2384266,0.94912079 51.7162424,5.92908192 49.1222157,24.5974477 Z",
      "id": "haileyBackground_face",
      "fill": "#EFAC60",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.002771,38.0445 C27.8035916,38.1915 32.3082074,38.22825 33.809746,38.00775 C34.6105666,37.8975 32.8087203,39 29.8056431,39 C26.8025659,39 27.002771,38.0445 27.002771,38.0445 Z",
      "id": "haileyBackground_mouth_bottom",
      "fill": "#E49237",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26,37.6551724 C26,36.7586207 26.5283266,36 29.2756246,36 C31.1776002,36 34.2418942,37.2413793 35.7740412,36.6896552 C36.0910371,36.5517241 36.0910371,36.8965517 35.6683759,37.1034483 C33.7135677,38 31.8115921,38 28.905796,38 C27.0038204,37.9310345 26,37.6551724 26,37.6551724 Z",
      "id": "haileyBackground_mouth_top",
      "fill": "#E49237",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28.2084337,23.7669746 C28.2084337,22.7877 30.6493088,22.7018834 30.6505083,23.7669746 C30.6517078,24.8320658 31.4354651,30.3897096 30.6517078,31.3772811 C29.8679505,32.3648526 27.563999,32.0339697 27.2074458,31.3772811 C26.8508926,30.7205924 26.9181249,29.6496811 27.6915665,29.3513664 C28.4650081,29.0530517 28.2084337,24.7462493 28.2084337,23.7669746 Z",
      "id": "haileyBackground_nose",
      "fill": "#E49237"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M35,25.3566903 C36.3081052,21.4202598 42.1257308,20.8194947 42.9999982,24.2282667 C43.0041486,28.8311962 35.9509275,29.2377449 35,25.3566903 Z",
      "id": "haileyBackground_left_eye_whites",
      "fill": "#FBD79E"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "haileyBackground_left_pupil",
      "fill": "#AE6C23",
      "cx": "37.75",
      "cy": "25",
      "r": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26,25.3566903 C24.6918948,21.4202598 18.8742692,20.8194947 18.0000018,24.2282667 C17.9958514,28.8311962 25.0490725,29.2377449 26,25.3566903 Z",
      "id": "haileyBackground_right_eye_whites",
      "fill": "#FBD79E"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "haileyBackground_right_pupil",
      "fill": "#AE6C23",
      "cx": "20.75",
      "cy": "25",
      "r": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26.4607984,18.5811051 C25.4007132,17.8680939 19.8217011,17.7468699 18.5984569,18.5811051 C17.3752128,19.4153402 18.2708594,20.2372803 19.122613,19.9129095 C19.9743667,19.5885387 25.03191,19.5221754 25.9366423,19.9129095 C26.8413747,20.3036436 27.5208837,19.2941163 26.4607984,18.5811051 Z",
      "id": "haileyBackground_right_brow",
      "fill": "#E39B4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23.4955227,7.12205422 C26.3408205,18.0772693 33.6790757,19.2326019 41.794949,21.2646559 C49.9108222,23.29671 44.4297528,32.8840684 41.2408901,37 C45.2833421,35.4357843 51.7065198,31.3173759 51.8909172,24.3179669 C52.138671,14.913655 53.3617135,0.0417199132 34.8084848,0.000118432424 C16.255256,-0.0414830484 14.9160788,10.8828281 15.0036637,23.335221 C16.0498429,18.6235562 18.3797934,11.9863371 23.4955227,7.12205422 Z",
      "id": "haileyBackground_bangs",
      "fill": "#E39B4A"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-808568c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_6/svg/backgroundCharacters/haileyBackground.vue
// module id = 962
// module chunks = 1